/* qeslint-disable */
// q@ts-nocheck

import {
    Cartesian3,
    Cesium3DTileset,
    Math as CesiumMath,
    OrthographicFrustum,
    PerspectiveFrustum,
    Scene,
    Viewer
} from "cesium";
import type Construkted from "./Construkted";

import { CameraPositionOrientation, RelativeCameraPositionOrientation } from "./types/common";
import { calculateTightBoundinSphere } from "./calculateTightBoundingSphere";

export const isLocal = () =>
    // eslint-disable-next-line no-restricted-globals
    location.hostname === "cesiumgis.com" || location.hostname === "localhost" || location.hostname === "127.0.0.1";

// eslint-disable-next-line no-restricted-globals
export const isGw4 = () => location.hostname === "gw4.construkted.com";

export function isMobile() {
    let check = false;

    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            // eslint-disable-next-line no-useless-escape
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        ) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);

    return check;
}

export const showHideTilesInspector = (show: boolean) => {
    if (show) {
        jQuery(".cesium-viewer-cesium3DTilesInspectorContainer").show();
    } else {
        jQuery(".cesium-viewer-cesium3DTilesInspectorContainer").hide();
    }
};

export const disableDefaultScreenSpaceCameraController = (scene: Scene) => {
    scene.screenSpaceCameraController.enableRotate = false;
    scene.screenSpaceCameraController.enableTranslate = false;
    scene.screenSpaceCameraController.enableZoom = false;
    scene.screenSpaceCameraController.enableTilt = false;
    scene.screenSpaceCameraController.enableLook = false;
};

export const enableDefaultScreenSpaceCameraController = (scene: Scene) => {
    scene.screenSpaceCameraController.enableRotate = true;
    scene.screenSpaceCameraController.enableTranslate = true;
    scene.screenSpaceCameraController.enableZoom = true;
    scene.screenSpaceCameraController.enableTilt = true;
    scene.screenSpaceCameraController.enableLook = true;
};

export const flyToTileset = (options: {
    viewer: Viewer;
    tileset: Cesium3DTileset;
    defaultCameraPositionDirection: RelativeCameraPositionOrientation | CameraPositionOrientation | undefined;
    complete?: () => void;
}) => {
    const viewer = options.viewer;
    const camera = viewer.camera;
    const tileset = options.tileset;
    const defaultCameraPositionDirection = options.defaultCameraPositionDirection;

    const cameraPositionOrientation = defaultCameraPositionDirection as CameraPositionOrientation;
    const relativeCameraPositionOrientation = defaultCameraPositionDirection as RelativeCameraPositionOrientation;

    if (relativeCameraPositionOrientation && relativeCameraPositionOrientation.offsetX !== undefined) {
        const offset = new Cartesian3(
            relativeCameraPositionOrientation.offsetX,
            relativeCameraPositionOrientation.offsetY,
            relativeCameraPositionOrientation.offsetZ
        );

        const destination = Cartesian3.add(tileset.boundingSphere.center, offset, new Cartesian3());

        if (relativeCameraPositionOrientation.view_mode === "orthographic") {
            const currentFrustum = camera.frustum;
            const width = currentFrustum instanceof OrthographicFrustum ? currentFrustum.width : 100;
            const aspectRatio =
                camera.frustum instanceof OrthographicFrustum || camera.frustum instanceof PerspectiveFrustum
                    ? camera.frustum.aspectRatio
                    : undefined;

            camera.frustum = new OrthographicFrustum({
                width: width,
                aspectRatio: aspectRatio || 1.0
            });
        } else {
            const fov = relativeCameraPositionOrientation.field_of_view
                ? CesiumMath.toRadians(relativeCameraPositionOrientation.field_of_view)
                : CesiumMath.toRadians(60);
            const aspectRatio =
                camera.frustum instanceof OrthographicFrustum || camera.frustum instanceof PerspectiveFrustum
                    ? camera.frustum.aspectRatio
                    : undefined;

            camera.frustum = new PerspectiveFrustum({
                fov: fov,
                aspectRatio: aspectRatio || 1.0
            });
        }

        viewer.camera.flyTo({
            destination: destination,
            orientation: {
                heading: CesiumMath.toRadians(relativeCameraPositionOrientation.heading),
                pitch: CesiumMath.toRadians(relativeCameraPositionOrientation.pitch),
                roll: CesiumMath.toRadians(relativeCameraPositionOrientation.roll)
            },
            complete: options.complete
        });
    } else if (cameraPositionOrientation && cameraPositionOrientation.longitude !== undefined) {
        const destination = Cartesian3.fromDegrees(
            cameraPositionOrientation.longitude,
            cameraPositionOrientation.latitude,
            cameraPositionOrientation.height
        );

        if (cameraPositionOrientation.view_mode === "orthographic") {
            const currentFrustum = camera.frustum;
            const width = currentFrustum instanceof OrthographicFrustum ? currentFrustum.width : 100;
            const aspectRatio =
                camera.frustum instanceof OrthographicFrustum || camera.frustum instanceof PerspectiveFrustum
                    ? camera.frustum.aspectRatio
                    : undefined;

            camera.frustum = new OrthographicFrustum({
                width: width,
                aspectRatio: aspectRatio || 1.0
            });
        } else {
            const fov = cameraPositionOrientation.field_of_view
                ? CesiumMath.toRadians(cameraPositionOrientation.field_of_view)
                : CesiumMath.toRadians(60);
            const aspectRatio =
                camera.frustum instanceof OrthographicFrustum || camera.frustum instanceof PerspectiveFrustum
                    ? camera.frustum.aspectRatio
                    : undefined;

            camera.frustum = new PerspectiveFrustum({
                fov: fov,
                aspectRatio: aspectRatio || 1.0
            });
        }

        viewer.camera.flyTo({
            destination: destination,
            orientation: {
                heading: CesiumMath.toRadians(cameraPositionOrientation.heading),
                pitch: CesiumMath.toRadians(cameraPositionOrientation.pitch),
                roll: CesiumMath.toRadians(cameraPositionOrientation.roll)
            },
            complete: options.complete
        });
    } else {
        const boundingSphere = calculateTightBoundinSphere(tileset);

        camera.flyToBoundingSphere(boundingSphere, {
            complete: options.complete
        });
    }
};

export const decodeEntities = (function () {
    // this prevents any overhead from creating the object each time
    const element = document.createElement("div");

    function decodeHTMLEntities(str: any) {
        if (str && typeof str === "string") {
            // strip script/html tags
            // eslint-disable-next-line no-param-reassign
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
            // eslint-disable-next-line no-param-reassign
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
            element.innerHTML = str;
            // eslint-disable-next-line no-param-reassign
            str = element.textContent;
            element.textContent = "";
        }

        return str;
    }

    return decodeHTMLEntities;
})();

export const getTiesetURL = (tilesetServer: string, postSlug: string, newStyleURL: boolean) => {
    const oldTilesetURL = `${tilesetServer}/${postSlug}/tileset.json`;
    const newTilesetURL = `${tilesetServer}/${postSlug}/tileset/tileset.json`;

    if (newStyleURL) {
        return newTilesetURL;
    }

    return oldTilesetURL;
};

export const existUrl = (url: string) => {
    const request = new XMLHttpRequest();

    request.open("GET", url, false);
    request.send();

    if (request.status === 404) {
        return false;
    }

    return true;
};

type ActionName =
    | "access camera frustum"
    | "set 3D view mode"
    | "set 2D view mode"
    | "set 2D north-up view mode"
    | "set wireframe shading"
    | "set solid shading"
    | "set textured shading"
    | "show layers panel";

const warnMissingConstrukted = (actionName: ActionName) => {
    console.warn(`ConstruktedApi: skipped ${actionName}; window.Construkted is not initialised yet.`);
};

const withConstrukted = <T>(actionName: ActionName, action: (instance: Construkted) => T, fallback?: T) => {
    const instance = window.Construkted;

    if (!instance) {
        warnMissingConstrukted(actionName);

        return fallback;
    }

    return action(instance);
};

export const construktedApi = {
    getCameraFrustum() {
        return withConstrukted("access camera frustum", (instance) => instance.cesiumViewer?.camera?.frustum);
    },

    set3DViewMode() {
        withConstrukted("set 3D view mode", (instance) => {
            instance.set3DViewMode();
        });
    },

    set2DViewMode() {
        withConstrukted("set 2D view mode", (instance) => {
            instance.set2DViewMode();
        });
    },

    set2DNorthUpViewMode() {
        withConstrukted("set 2D north-up view mode", (instance) => {
            instance.set2DViewNorthUpMode();
        });
    },

    setWireframeShadingMode() {
        withConstrukted("set wireframe shading", (instance) => {
            instance.setWireframeShadingMode();
        });
    },

    setSolidShadingMode() {
        withConstrukted("set solid shading", (instance) => {
            instance.setSolidShadingMode();
        });
    },

    setTextureShadingMode() {
        withConstrukted("set textured shading", (instance) => {
            instance.setTextureShadingMode();
        });
    },

    showLayersPanel() {
        withConstrukted("show layers panel", (instance) => {
            instance.layersPanel.show();
        });
    }
};
